import React, { useEffect, useReducer } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Board from './pages/Board';
import TaskDetail from './pages/TaskDetail';
import Settings from './pages/Settings';
import { isLoggedIn, onAuthChange } from './storage';

export default function App() {
  // Re-render whenever auth state changes (login / logout / register).
  // Without this, the routes below are evaluated only on the first render
  // and a successful login would leave the user stuck on the login page
  // (they'd have to refresh to see the inner pages).
  const [, force] = useReducer((x) => x + 1, 0);
  useEffect(() => onAuthChange(force), []);

  if (!isLoggedIn()) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Board />} />
      <Route path="/task/:id" element={<TaskDetail />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
